export const onClientEntry = () => {
  const script = document.createElement('script');
  script.src =
    'https://platform.illow.io/banner.js?siteId=aea86a5c-00f3-47c1-bfa8-86cb394a8408';
  script.async = true;
  document.head.appendChild(script);
};
